module.exports = __webpack_public_path__ + "static/media/Responsibilty-Matrix.4718c1b4.pdf";